import { pageLoadingStatusMixin } from 'relapp-loading';
import { mapGetters, mapActions } from 'vuex';

import UsersApi from '../services/api/user.js';
import store from '@/store/index.js';

export default {
    mixins: [pageLoadingStatusMixin],
    computed: {
        ...mapGetters({
            currentCustomer: 'user/currentCustomer',
            currentUser: 'user/user',
            userCan: 'user/can',
            userRoles: 'users/roles',
            users: 'users/items'
        })
    },
    /**
     * Called after the instance has been mounted.
     */
    mounted() {
        this.getUsers();
        this.getUserRoles();
    },
    methods: {
        ...mapActions({
            removeUser: 'users/removeUser'
        }),
        /**
         * Get the users.
         */
        getUsers() {
            if (this.currentCustomer && this.currentCustomer.availableActions.includes('listUsers')) {
                UsersApi.get().then(this.finishLoading);
            }
        },
        /**
         * Get the user roles.
         */
        getUserRoles() {
            if (this.currentCustomer && this.currentCustomer.availableActions.includes('listUsers')) {
                UsersApi.getRoles().then(this.finishLoading);
            }
        }
    },
    /**
     * Check if we can enter the route.
     *
     * @param {object} to
     * @param {object} from
     * @param {function} next
     */
    beforeRouteEnter(to, from, next) {
        if (store.getters['user/currentCustomer'].availableActions.includes('listUsers')) {
            next();

            return;
        }

        next({ name: 'error.403' });
    }
};
